import { useMutation, MutationHookOptions } from '@apollo/react-hooks';
import { GRANT_RESOURCE_ACCESS_MUTATION } from '@frontend/app/queries';
import {
  GrantResourceAccessMutation,
  GrantResourceAccessMutationVariables,
} from '@frontend/app/queries/types/GrantResourceAccessMutation';

type TOptions = MutationHookOptions<GrantResourceAccessMutation, GrantResourceAccessMutationVariables>;

export const useGrantResourceAccessMutation = (options: TOptions = {}) =>
  useMutation<GrantResourceAccessMutation, GrantResourceAccessMutationVariables>(
    GRANT_RESOURCE_ACCESS_MUTATION,
    options,
  );
